import React, { FC } from 'react';
import { Transition } from 'react-transition-group';

import { CaretContainer, hideAnimationSpeed, TopicTitleContainer } from '~src/modules/heatmap/components/table/topicTitle.sc';
import { BoxPadding } from '~src/modules/heatmap/components/table/row/rows.sc';

interface Props {
  text: string;
  id: string;
  select?: (val: string) => void;
  isFixed?: boolean;
  isHidden?: boolean;
}

const ColumnTitle: FC<Props> = props => {
  const selectThis = () => {
    if (props.select && !props.isHidden) {
      props.select(props.id);
    }
  };

  return (
    <Transition in={!props.isHidden} timeout={hideAnimationSpeed}>
      {status => (
        <TopicTitleContainer
          $isHidden={props.isHidden}
          $isFixed={props.isFixed}
          className={status}
          onClick={selectThis}
        >
          {!props.isHidden && (
            <BoxPadding $showFade={props.text.length > 50}>
              <div>
                <CaretContainer $isFixed={props.isFixed} width={10} height={10} name="iconDropDownArrow" />
                <span>{props.text}</span>
              </div>
            </BoxPadding>
          )}
        </TopicTitleContainer>
      )}
    </Transition>
  );
};

export default React.memo(ColumnTitle);
